/* MK 01.10.2026 : adresses dans la langue de la page (FR, IT, DE…) ; en anglais, inchangé */
function mkIgRoot() { try { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; } catch (e) { return '/'; } }
function mkIgHref(ctx, url) {
  if (!ctx) return url;
  var root = mkIgRoot(), path = url;
  if (root !== '/' && path.indexOf(root) === 0) path = path.slice(root.length - 1);
  /* MK 02.10.2026 : Season One a la cle s1 dans MK_GC ; sinon on garde au moins la langue de la page */
  var gc = window.MK_GC || {}, key = (ctx === 'season-one') ? 's1' : ctx;
  var base = gc[key] || gc[ctx] || ((root !== '/' ? root.slice(0, -1) : '') + '/collections/' + ctx);
  return base + path;
}
/* MK 01.10.2026 : textes traduits fournis par window.MK_I18N.c (layout/theme.liquid) ; anglais par défaut */
function mkT(k, d) { try { return (window.MK_I18N && window.MK_I18N.c && window.MK_I18N.c[k]) || d; } catch (e) { return d; } }
/* MK: full-screen lightbox on mobile — true full screen where the browser allows it (Android), black background and black browser bars (theme-color) elsewhere; restored on close */
window.mkLbEnter = function () {
  try {
    var html = document.documentElement;
    html.classList.add('mk-lb-open');
    var meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) { meta = document.createElement('meta'); meta.setAttribute('name', 'theme-color'); document.head.appendChild(meta); }
    if (meta.__mkPrev === undefined) meta.__mkPrev = meta.getAttribute('content') || '';
    meta.setAttribute('content', '#000000');
    /* True full screen (K's choice, 25 Sept.): the browser hides its bars but shows its own short "swipe to exit" message */
    if (window.innerWidth <= 749 && !document.fullscreenElement && !document.webkitFullscreenElement) {
      var rf = html.requestFullscreen || html.webkitRequestFullscreen;
      if (rf) { var p = rf.call(html, { navigationUI: 'hide' }); if (p && p.catch) p.catch(function () {}); }
    }
  } catch (e) {}
};
window.mkLbExit = function () {
  try {
    document.documentElement.classList.remove('mk-lb-open');
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta && meta.__mkPrev !== undefined) { meta.setAttribute('content', meta.__mkPrev); meta.__mkPrev = undefined; }
    if (document.fullscreenElement && document.exitFullscreen) { var p = document.exitFullscreen(); if (p && p.catch) p.catch(function () {}); }
    else if (document.webkitFullscreenElement && document.webkitExitFullscreen) document.webkitExitFullscreen();
  } catch (e) {}
};
(function(){
  function sizeOptionIndex(p){
    for(var i=0;
    i<p.options.length;
    i++)if(/size/i.test(p.options[i].name))return i;
    return-1
  }function soundOnSVG(){
    return'<svg viewBox="0 0 24 24" fill="none"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="#fff"/><path d="M16 8.5c1 1 1.6 2.2 1.6 3.5s-.6 2.5-1.6 3.5M18.5 6c1.8 1.8 2.8 4 2.8 6s-1 4.2-2.8 6" stroke="#fff" stroke-width="1.4" stroke-linecap="round"/></svg>'
  }function soundOffSVG(){
    return'<svg viewBox="0 0 24 24" fill="none"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="#fff"/><path d="M15.5 9.5l5 5M20.5 9.5l-5 5" stroke="#fff" stroke-width="1.4" stroke-linecap="round"/></svg>'
  }function playIconSVG(){
    return'<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linejoin="round"><path d="M8 5.5v13l10-6.5z"/></svg>'
  }function collectPosts(grid){
    var order=[], map={

    };
    return grid.querySelectorAll(":scope > .ig-media-source").forEach(function(src){
      var group=src.getAttribute("data-group");
      map[group]||(map[group]=[], order.push(group)), map[group].push(src)
    }), order.map(function(group){
      return map[group]
    })
  }function readTags(src){
    for(var tags=[], i=1;
    i<=5;
    i++){
      var handle=src.getAttribute("data-tag-"+i+"-handle");
      handle&&tags.push({
        handle:handle, x:parseFloat(src.getAttribute("data-tag-"+i+"-x"))||50, y:parseFloat(src.getAttribute("data-tag-"+i+"-y"))||50, info:src.getAttribute("data-tag-"+i+"-info")||""
      })
    }return tags
  }/* MK 27.09.2026 : plein écran mobile (≤ 749 px). Règle de cadrage de chaque photo :
     1. champ « cadrage_mobile » de la photo s'il est rempli (0 = gauche, 50 = centre, 100 = droite), réglé sur le visage ;
     2. sinon, cadrage automatique centré sur les produits taggés (les points restent à l'écran) ;
     3. sans tag, centre.
     Les points sont recalculés sur la partie de l'image réellement visible ; ceux qui sortent de l'écran sont masqués. Rien ne change sur ordinateur. */
  function mkBox(){
    var box=lightboxPanelEl||null;
    return {w:(box&&box.clientWidth)||window.innerWidth, h:(box&&box.clientHeight)||window.innerHeight}
  }
  function mkFocus(m){
    if(!(window.innerWidth<=749)||m.type==="video"||!m.iw||!m.ih||m.imageMobile) return null;
    if(m.focusX!==null&&m.focusX!==undefined&&!isNaN(m.focusX)) return m.focusX;
    if(!m.tags||!m.tags.length) return 50;
    var c=mkBox(), v=Math.min(1,(c.w/c.h)/(m.iw/m.ih));
    if(v>=0.999) return 50;
    var xs=m.tags.map(function(t){return t.x}), mid=(Math.min.apply(null,xs)+Math.max.apply(null,xs))/200;
    return Math.max(0,Math.min(100,(mid-v/2)/(1-v)*100))
  }
  function mkMapTags(m){
    try{
      var f=mkFocus(m);
      if(f===null) return m.tags;
      var c=mkBox(), cw=c.w, ch=c.h, s=Math.max(cw/m.iw, ch/m.ih), dw=m.iw*s, dh=m.ih*s, ox=(cw-dw)*f/100, oy=(ch-dh)/2;
      return m.tags.map(function(t){
        return {handle:t.handle, info:t.info, x:Math.round((ox+t.x/100*dw)/cw*1000)/10, y:Math.round((oy+t.y/100*dh)/ch*1000)/10}
      }).filter(function(t){ return t.x>=2&&t.x<=98&&t.y>=2&&t.y<=98 })
    }catch(e){ return m.tags }
  }
  /* MK 27.09.2026 : ouverture de la vidéo plein écran plus rapide, sur téléphone.
     Si le téléphone lit le HLS nativement (iPhone, Android), on prend le flux HLS de Shopify : il démarre en qualité légère puis monte jusqu'au 1080p.
     Sinon, le MP4 1080p comme avant. L'image d'attente de la vidéo mobile est préchargée dès l'arrivée sur la page. */
  var mkCanHls=(function(){ try{ return !!document.createElement("video").canPlayType("application/vnd.apple.mpegurl") }catch(e){ return false } })();
  var mkTouch=("ontouchstart" in window)||(navigator.maxTouchPoints>0);
  function mkVid(hls, mp4){
    if(false&&mkCanHls&&hls&&window.innerWidth<=749&&mkTouch){ (window.__mkHlsMap=window.__mkHlsMap||{})[hls.replace(/^https?:/,"")]=mp4||""; return hls }
    return mp4||""
  }
  /* Filet de sécurité : si un téléphone n'arrive pas à lire le HLS, on repasse sur le MP4. */
  document.addEventListener("error", function(e){
    var v=e.target;
    if(!v||v.tagName!=="VIDEO"||!window.__mkHlsMap) return;
    var s=(v.currentSrc||v.src||"").replace(/^https?:/,"");
    for(var k in window.__mkHlsMap){
      if(window.__mkHlsMap[k]&&s.indexOf(k.split("?")[0])>-1){ v.src=window.__mkHlsMap[k]; try{ v.load(); var p=v.play(); p&&p.catch&&p.catch(function(){}) }catch(err){} break }
    }
  }, true);
  function mkWarm(u){
    try{ if(u&&window.innerWidth<=749){ var im=new Image(); im.decoding="async", im.src=u; im.decode&&im.decode().catch(function(){}); window.__mkPre=(window.__mkPre||[]).concat(im).slice(-6) } }catch(e){}
    return u
  }
  function mediaData(src){
    return{
      type:src.getAttribute("data-media-type"), image:src.getAttribute("data-image")||"", imageAlt:src.getAttribute("data-image-alt")||"", videoSrc:mkVid(src.getAttribute("data-video-hls"), src.getAttribute("data-video-src")), poster:src.getAttribute("data-poster")||"", caption:src.getAttribute("data-caption")||"", fullWidth:src.getAttribute("data-full-width")==="true", imageMobile:src.getAttribute("data-image-mobile")||"", imageFull:src.getAttribute("data-image-full")||"", videoMobileSrc:mkVid(src.getAttribute("data-video-mobile-hls"), src.getAttribute("data-video-mobile-src")), posterMobile:mkWarm(src.getAttribute("data-poster-mobile")||""), tags:readTags(src), iw:parseFloat(src.getAttribute("data-image-w"))||0, ih:parseFloat(src.getAttribute("data-image-h"))||0, focusX:(src.getAttribute("data-focus-x")||"")!==""?parseFloat(src.getAttribute("data-focus-x")):null
    }
  }var lightboxEl, lightboxPanelEl, wrapA, wrapB, activeWrap, allPosts=[], currentPostIndex=0, animating=!1, lb={
    track:null, slides:null, current:0, medias:null, goToSlide:null, openSheetForSlide:null, closeSheet:null, updateMediaAspect:null
  };
  function makeWrap(){
    var wrap=document.createElement("div");
    wrap.className="ig-lightbox__postwrap", wrap.style.touchAction="pinch-zoom";
    var media=document.createElement("div");
    media.className="ig-lightbox__media";
    var caption=document.createElement("div");
    return caption.className="ig-lightbox__caption", wrap.appendChild(media), wrap.appendChild(caption), wrap.__media=media, wrap.__caption=caption, wrap
  }function buildSlide(m){
    var slide=document.createElement("div");
    if(slide.className="ig-slide", m.type==="video"&&m.videoSrc){
      var video=document.createElement("video");
      video.src=(window.innerWidth<=749&&m.videoMobileSrc?m.videoMobileSrc:m.videoSrc), (window.innerWidth<=749&&m.videoMobileSrc?(m.posterMobile&&(video.poster=m.posterMobile)):(m.poster&&(video.poster=m.poster))), video.muted=!1, video.loop=!0, video.playsInline=!0, video.setAttribute("playsinline", ""), video.disableRemotePlayback=!0, video.setAttribute("disableRemotePlayback", ""), video.setAttribute("x-webkit-airplay", "deny"), video.disablePictureInPicture=!0, video.preload="auto", slide.appendChild(video)
    }else{
      var img=document.createElement("img");
     img.src=mkImgUrl(m), img.alt=m.imageAlt, img.loading="eager", img.decoding="async", img.draggable=!1, (function(){ var f=mkFocus(m); f!==null&&(img.style.objectPosition=f+"% 50%") })(), slide.appendChild(img)
    }return mkMapTags(m).forEach(function(tag){
      var dot=document.createElement("button");
      dot.type="button", dot.className="ig-tag-dot is-pulsing", dot.style.left=tag.x+"%", dot.style.top=tag.y+"%", dot.setAttribute("aria-label", mkT('s_c1445852edff', "View product")), dot.dataset.handle=tag.handle, slide.appendChild(dot);
      if(tag.info){
        var label=document.createElement("span");
        label.className="ig-tag-label"+(tag.x>50?" ig-tag-label--left":" ig-tag-label--right");
        label.dataset.handle=tag.handle;
        label.style.top=tag.y+"%";
        var lineEl=document.createElement("span");
        lineEl.className="ig-tag-label__line";
        var textEl=document.createElement("span");
        textEl.className="ig-tag-label__text";
        textEl.textContent=tag.info;
        if(tag.x>50){
          label.style.right="calc("+(100-tag.x)+"% + 14px)";
          label.appendChild(textEl), label.appendChild(lineEl)
        } else {
          label.style.left="calc("+tag.x+"% + 14px)";
          label.appendChild(lineEl), label.appendChild(textEl)
        }
                var slideW=window.innerWidth;
        var dotPx=(tag.x/100)*slideW;
        var reserve=46;
        var maxW=tag.x>50?(dotPx-reserve):(slideW-dotPx-reserve);
        maxW=Math.max(60,Math.min(maxW,slideW-32));
        label.style.maxWidth=maxW+"px";
        slide.appendChild(label)
      }
    }), slide
  }function renderPostInto(wrapEl, postIndex, startIndex){
    var medias=allPosts[postIndex], mediaEl=wrapEl.__media;
    mediaEl.innerHTML="";
    var track=document.createElement("div");
    track.className="ig-tile__track";
    var slides=medias.map(buildSlide);
    slides.forEach(function(s){
      track.appendChild(s)
    }), mediaEl.appendChild(track);
    var current=startIndex||0;
    if(slides.length>1){
      var dots=document.createElement("div");
      dots.className="ig-dots", slides.forEach(function(_, i){
        var d=document.createElement("span");
        i===current&&d.classList.add("is-active"), dots.appendChild(d)
      }), mediaEl.appendChild(dots)
      var progress=document.createElement("div");progress.className="ig-lightbox-progress";slides.forEach(function(_,i){var p=document.createElement("span");i===current&&p.classList.add("is-active");progress.appendChild(p)});mediaEl.appendChild(progress)
    }current>0&&(track.style.transform="translateX(-"+current*100+"%)");
    var hasAnyVideo=medias.some(function(m){
      return m.type==="video"
    });
    if(hasAnyVideo){
      var soundBtn=document.createElement("button");
      soundBtn.type="button", soundBtn.className="ig-sound-btn", soundBtn.setAttribute("aria-label", mkT('s_006ef81ff83b', "Toggle sound")), soundBtn.innerHTML=soundOnSVG();
      var toggleSound=function(){
        var anyMuted=Array.prototype.some.call(mediaEl.querySelectorAll("video"), function(v){
          return v.muted
        });
        mediaEl.querySelectorAll("video").forEach(function(v){
          v.muted=!anyMuted
        }), soundBtn.innerHTML=anyMuted?soundOnSVG():soundOffSVG()
      };
      var lastToggle=0;
      document.addEventListener("pointerdown", function(e){
        if(!soundBtn.offsetParent) return;
        var rct=soundBtn.getBoundingClientRect(), pad=14;
        if(rct.width<=0) return;
        if(e.clientX>=rct.left-pad && e.clientX<=rct.right+pad && e.clientY>=rct.top-pad && e.clientY<=rct.bottom+pad){
          var now=Date.now();
          if(now-lastToggle>300){
            lastToggle=now;
            e.preventDefault();
            toggleSound()
          }
        }
      }, true);
      mediaEl.appendChild(soundBtn)
    }function updateVideoPlayback(){
      slides.forEach(function(slide, i){
        var v=slide.querySelector("video");
        v&&(i===current?(v.dataset.mkWant="1", v.getAttribute("src")&&v.play().catch(function(){})):(v.dataset.mkWant="0", v.pause()))
      })
    }function pauseAll(){
      slides.forEach(function(slide){
        var v=slide.querySelector("video");
        v&&v.pause()
      })
    }function fitMediaBox(w, h){
      if(window.innerWidth<=749){
        mediaEl.style.width="", mediaEl.style.height="";
        return
      }var containerW=lightboxPanelEl.clientWidth||window.innerWidth, containerH=lightboxPanelEl.clientHeight||window.innerHeight;
      if(!w||!h){
        mediaEl.style.width=containerW+"px", mediaEl.style.height=containerH+"px";
        return
      }var ratio=w/h, height=containerH, width=height*ratio;
      width>containerW&&(width=containerW, height=width/ratio), mediaEl.style.width=width+"px", mediaEl.style.height=height+"px"
    }function updateMediaAspect(){
      var m=medias[current];
      if(m.type==="video"){
        var v=slides[current].querySelector("video");
        v&&v.videoWidth&&v.videoHeight?fitMediaBox(v.videoWidth, v.videoHeight):v&&(fitMediaBox(4, 5), v.addEventListener("loadedmetadata", function(){
          medias[current]===m&&fitMediaBox(v.videoWidth, v.videoHeight)
        }, {
          once:!0
        }))
      }else{
        var img=slides[current].querySelector("img");
        img&&img.naturalWidth&&img.naturalHeight?fitMediaBox(img.naturalWidth, img.naturalHeight):img&&(fitMediaBox(4, 5), img.addEventListener("load", function(){
          medias[current]===m&&fitMediaBox(img.naturalWidth, img.naturalHeight)
        }, {
          once:!0
        }))
      }
    }function goToSlide(index){
      current=Math.max(0, Math.min(slides.length-1, index)), ctl.current=current, track.style.transform="translateX(-"+current*100+"%)", mediaEl.querySelectorAll(".ig-dots span").forEach(function(d, i){
        d.classList.toggle("is-active", i===current)
      }), mediaEl.querySelectorAll(".ig-lightbox-progress span").forEach(function(d, i){
        d.classList.toggle("is-active", i===current)
      }), updateVideoPlayback(), updateMediaAspect(), ctl.closeSheet&&ctl.closeSheet(), history.state&&history.state.igLightboxPost===postIndex&&history.replaceState({
        igLightboxPost:postIndex, igLightboxSlide:current
      }, "", location.href)
    }updateVideoPlayback(), updateMediaAspect();
    var ctl={
      postIndex:postIndex, track:track, slides:slides, current:current, medias:medias, goToSlide:goToSlide, updateMediaAspect:updateMediaAspect, updateVideoPlayback:updateVideoPlayback, pauseAll:pauseAll, closeSheet:null, openSheetForSlide:null
    };
    return wrapEl.__ctl=ctl, ctl
  }/* MK 26.09.2026 : mobile, glisser le tiroir Tagged products vers le bas pour le fermer */
  function attachSheetSwipe(sheet, ctl){
    var sx=0, sy=0, dy=0, ly=0, lt=0, v=0, state=0;
    sheet.style.overscrollBehavior="contain";
    sheet.addEventListener("touchstart", function(e){
      if(!sheet.classList.contains("is-open")||e.touches.length>1){state=3;return}
      var p=e.touches[0];
      sx=p.clientX; sy=ly=p.clientY; lt=Date.now(); dy=0; v=0; state=1
    }, {passive:true});
    sheet.addEventListener("touchmove", function(e){
      if(state!==1&&state!==2) return;
      if(e.touches.length>1){state=3; sheet.style.transition=""; sheet.style.transform=""; return}
      var p=e.touches[0], y=p.clientY, now=Date.now();
      if(state===1){
        var ddy=y-sy, ddx=p.clientX-sx;
        if(ddy===0&&Math.abs(ddx)<6) return;
        if(ddy>0&&ddy>=Math.abs(ddx)&&sheet.scrollTop<=0){state=2; sheet.style.transition="none"}
        else {state=3; return}
      }
      e.preventDefault();
      dy=Math.max(0, y-sy);
      v=(y-ly)/Math.max(1, now-lt); ly=y; lt=now;
      sheet.style.transform="translateY("+dy+"px)"
    }, {passive:false});
    function endSwipe(){
      if(state!==2){state=0; return}
      state=0; sheet.style.transition="";
      if(dy>sheet.offsetHeight*0.3||(v>0.5&&dy>10)){ ctl.closeSheet&&ctl.closeSheet() }
      else { sheet.style.transform="" }
      dy=0
    }
    /* MK 26.09.2026 : même geste à la souris sur ordinateur */
    var md=null, justDragged=false, grabEls=sheet.querySelectorAll(".ig-sheet__handle, .ig-sheet__title");
    for(var gi=0; gi<grabEls.length; gi++){ grabEls[gi].style.cursor="grab" }
    sheet.addEventListener("dragstart", function(e){ if(md) e.preventDefault() });
    sheet.addEventListener("pointerdown", function(e){
      if(e.pointerType==="touch"||e.button!==0||!sheet.classList.contains("is-open")) return;
      md={id:e.pointerId, x:e.clientX, y:e.clientY, ly:e.clientY, lt:Date.now(), v:0, dy:0, on:false}
    });
    sheet.addEventListener("pointermove", function(e){
      if(!md||e.pointerId!==md.id) return;
      var ddy=e.clientY-md.y, ddx=e.clientX-md.x, now=Date.now();
      if(!md.on){
        if(Math.abs(ddy)<6&&Math.abs(ddx)<6) return;
        if(ddy>0&&ddy>=Math.abs(ddx)&&sheet.scrollTop<=0){
          md.on=true; md.y=e.clientY; sheet.style.transition="none"; sheet.style.cursor="grabbing";
          try{ sheet.setPointerCapture(md.id) }catch(err){}
          try{ window.getSelection().removeAllRanges() }catch(err){}
          document.documentElement.style.userSelect="none"
        } else { md=null; return }
      }
      e.preventDefault();
      md.dy=Math.max(0, e.clientY-md.y);
      md.v=(e.clientY-md.ly)/Math.max(1, now-md.lt); md.ly=e.clientY; md.lt=now;
      sheet.style.transform="translateY("+md.dy+"px)"
    });
    function endMouse(e){
      if(!md||(e&&e.pointerId!==md.id)) return;
      var d=md; md=null;
      if(!d.on) return;
      sheet.style.cursor=""; document.documentElement.style.userSelect="";
      justDragged=true; setTimeout(function(){ justDragged=false }, 0);
      sheet.style.transition="";
      if(d.dy>sheet.offsetHeight*0.3||(d.v>0.5&&d.dy>10)){ ctl.closeSheet&&ctl.closeSheet() }
      else { sheet.style.transform="" }
    }
    sheet.addEventListener("pointerup", endMouse);
    sheet.addEventListener("pointercancel", endMouse);
    sheet.addEventListener("click", function(e){ if(justDragged){ e.preventDefault(); e.stopPropagation(); justDragged=false } }, true);
    sheet.addEventListener("touchend", endSwipe);
    sheet.addEventListener("touchcancel", endSwipe)
  }
  /* MK 27.09.2026 : fluidité du swipe haut/bas en plein écran. Téléphone : photo en 1600 px (déjà chargée par la grille, nette à ~2,5x).
     Ordinateur : photo d'origine. Les posts voisins sont préchargés et décodés à l'avance. */
  /* MK 27.09.2026 : netteté du plein écran sur téléphone sans alourdir le swipe.
     La photo est demandée exactement à la taille dont l'écran a besoin (hauteur de l'écran x densité de pixels, jusqu'à 3x),
     arrondie aux 200 px supérieurs et plafonnée à la taille d'origine. Ex. écran 1080 x 2340 : photo de 1800 px de large (2400 de haut).
     Les posts voisins sont préchargés à la même taille, donc déjà prêts au swipe. Ordinateur : photo d'origine. */
  function mkImgUrl(m){
    try{
      if(!(window.innerWidth<=749)) return m.imageFull||m.image;
      if(m.imageMobile) return m.imageMobile;
      var base=m.imageFull||m.image;
      if(!base||!m.iw||!m.ih) return m.image||base;
      var c=mkBox(), dpr=Math.min(window.devicePixelRatio||2, 3), cw=Math.max(c.w, window.screen&&window.screen.width||0), ch=Math.max(c.h, window.screen&&window.screen.height||0);
      var needW=(cw/ch)<(m.iw/m.ih)?ch*dpr*m.iw/m.ih:cw*dpr;
      var w=Math.min(m.iw, Math.max(1000, Math.ceil(needW/200)*200));
      return /[?&]width=\d+/.test(base)?base.replace(/([?&])width=\d+/, "$1width="+w):base+(base.indexOf("?")>-1?"&":"?")+"width="+w
    }catch(e){ return m.image }
  }
  function mkPreload(idx){ setTimeout(function(){ mkPreloadNow(idx) }, 700) }
  function mkPreloadNow(idx){
    try{
      [idx+1, idx-1].forEach(function(i){
        var p=allPosts[i];
        if(!p||!p.length) return;
        var m=p[0];
        if(m.type==="video") return;
        var u=mkImgUrl(m);
        if(!u) return;
        var im=new Image();
        im.decoding="async", im.src=u, im.decode&&im.decode().catch(function(){});
        window.__mkPre=(window.__mkPre||[]).concat(im).slice(-6)
      })
    }catch(e){}
  }
  function activateController(ctl){
    currentPostIndex=ctl.postIndex; mkPreload(ctl.postIndex);
    var oldSheet=lightboxPanelEl.querySelector(".ig-sheet");
    oldSheet&&oldSheet.remove();
    var sheet=document.createElement("div");
    sheet.className="ig-sheet", sheet.innerHTML='<div class="ig-sheet__handle"></div><div class="ig-sheet__title">'+mkT('s_9d1eed0680a1', "Tagged products")+'</div><div class="ig-sheet__list"></div>', lightboxPanelEl.appendChild(sheet),ctl.closeSheet=function(){
      ctl.selectedByIndex={};
      sheet.style.transform="";
      sheet.classList.remove("is-open");
      ctl.slides.forEach(function(sl){
        sl.querySelectorAll(".ig-tag-label").forEach(function(lbl){
          lbl.classList.remove("is-open")
        })
      })
    } , attachSheetSwipe(sheet, ctl), ctl.selectedByIndex={}, ctl.openSheetForSlide=function(index, clickedHandle){
      var tags=ctl.medias[index].tags, list=sheet.querySelector(".ig-sheet__list");
      if(clickedHandle){
        ctl.selectedByIndex[index]=ctl.selectedByIndex[index]===clickedHandle?null:clickedHandle
      }
      var selected=ctl.selectedByIndex[index];
      (function(){
        var activeSlide=ctl.slides[index];
        if(!activeSlide) return;
        activeSlide.querySelectorAll(".ig-tag-label").forEach(function(lbl){
          lbl.classList.remove("is-open")
        });
        if(selected){
          activeSlide.querySelectorAll('.ig-tag-label[data-handle="'+selected+'"]').forEach(function(lbl){
            lbl.classList.add("is-open")
          })
        }
      })();
      list.innerHTML="";
      if(!selected){
        sheet.classList.remove("is-open");
        return
      }
      var ordered=tags.filter(function(t){
        return t.handle===selected
      }).concat(tags.filter(function(t){
        return t.handle!==selected
      }));
      var mkSeen={};
      ordered.forEach(function(tag){
        mkSeen[tag.handle]||(mkSeen[tag.handle]=1, renderSheetItem(list, tag.handle, mkModelCtx(tags, tag.handle)))
      }), sheet.classList.add("is-open")
    }, ctl.updateVideoPlayback(), lb=ctl
  }function initLightboxRefs(){
    if(lightboxEl=document.querySelector("[data-ig-lightbox]"), !!lightboxEl){
      lightboxPanelEl=lightboxEl.querySelector(".ig-lightbox__panel");
      var oldMedia=lightboxEl.querySelector("[data-ig-lightbox-media]"), oldCaption=lightboxEl.querySelector("[data-ig-lightbox-caption]"), oldWrap=oldMedia&&oldMedia.closest(".ig-lightbox__postwrap");
      oldWrap?oldWrap.remove():(oldMedia&&oldMedia.remove(), oldCaption&&oldCaption.remove()), wrapA=makeWrap(), wrapB=makeWrap(), wrapB.style.transition="none", wrapB.style.transform="translateY(100%)", lightboxPanelEl.appendChild(wrapA), lightboxPanelEl.appendChild(wrapB), activeWrap=wrapA, lightboxEl.querySelectorAll("[data-ig-close]").forEach(function(el){
        el.addEventListener("click", function(){
          closeLightbox()
        })
      }), document.addEventListener("keydown", function(e){
        e.key==="Escape"&&closeLightbox()
      }), window.addEventListener("popstate", function(e){
        var state=e.state;
        state&&state.igLightboxPost!==void 0&&allPosts[state.igLightboxPost]?openLightbox(state.igLightboxPost, state.igLightboxSlide||0, {
          fromPopstate:!0
        }):closeLightbox({
          fromPopstate:!0
        })
      }), attachLightboxInteractions(), window.addEventListener("resize", function(){
        lightboxEl&&!lightboxEl.hasAttribute("hidden")&&lb.updateMediaAspect&&lb.updateMediaAspect()
      })
    }
  }function closeLightbox(opts){
    if(opts=opts||{

    }, !(!lightboxEl||lightboxEl.hasAttribute("hidden"))){
      if(!opts.fromPopstate&&history.state&&history.state.igLightboxPost!==void 0){
        history.back();
        return
      }lightboxEl.setAttribute("hidden", ""), [wrapA, wrapB].forEach(function(w){
        w.__media.innerHTML="", w.__caption.textContent="", w.__media.querySelectorAll("video").forEach(function(v){
          v.pause()
        }), w.style.transition="none"
      }), activeWrap=wrapA, activeWrap.style.transform="translateY(0)", wrapB.style.transform="translateY(100%)", document.body.style.overflow="", window.mkLbExit&&window.mkLbExit(), mkResumeGrid(), animating=!1
    }
  }function goToPost(nextIndex, direction){
    if(!(nextIndex<0||nextIndex>=allPosts.length||animating)){
      animating=!0, lb.closeSheet&&lb.closeSheet();
      var outgoing=activeWrap, incoming=activeWrap===wrapA?wrapB:wrapA, outY=direction==="up"?"-100%":"100%", inY=direction==="up"?"100%":"-100%", ctl=renderPostInto(incoming, nextIndex, 0);
      incoming.style.transition="none", incoming.style.transform="translateY("+inY+")", outgoing.style.transition="transform 0.28s ease", outgoing.style.transform="translateY("+outY+")", requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          incoming.style.transition="transform 0.28s ease", incoming.style.transform="translateY(0)"
        })
      }), window.setTimeout(function(){
        activeWrap=incoming, activateController(ctl), outgoing.style.transition="none", outgoing.__media.querySelectorAll("video").forEach(function(v){
          v.pause()
        }), outgoing.__media.innerHTML="", animating=!1, history.state&&history.state.igLightboxPost!==void 0&&history.replaceState({
          igLightboxPost:nextIndex, igLightboxSlide:0
        }, "", location.href)
      }, 280)
    }
  }function attachLightboxInteractions(){
    lightboxPanelEl.addEventListener("click", function(e){
      var dot=e.target.closest(".ig-tag-dot");
      if(dot){
        e.preventDefault(), e.stopPropagation(), lb.openSheetForSlide&&lb.openSheetForSlide(lb.current, dot.dataset.handle);
        return
      }!e.target.closest(".ig-sheet")&&!e.target.closest(".ig-sound-btn")&&lb.closeSheet&&lb.closeSheet()
    });
    var startX=0, startY=0, deltaX=0, deltaY=0, axis=null, dragging=!1, dragRaf=null, activePointers=new Set();
    lightboxPanelEl.addEventListener("pointerdown", function(e){
      activePointers.add(e.pointerId);
      if(activePointers.size>1){dragging=!1;return}
      animating||e.target.closest(".ig-sheet")||e.target.closest(".ig-sound-btn")||e.target.closest(".ig-tag-dot")||(dragging=!0, axis=null, deltaX=0, deltaY=0, startX=e.clientX, startY=e.clientY, lb.track&&(lb.track.style.transition="none"))
    }), lightboxPanelEl.addEventListener("pointermove", function(e){
      dragging&&activePointers.size===1&&(deltaX=e.clientX-startX, deltaY=e.clientY-startY, !axis&&(Math.abs(deltaX)>8||Math.abs(deltaY)>8)&&(axis=Math.abs(deltaY)>Math.abs(deltaX)?"y":"x"), axis==="x"&&lb.slides&&lb.slides.length>1&&e.preventDefault(), axis==="y"&&allPosts.length>1&&(e.preventDefault(), dragRaf||(dragRaf=requestAnimationFrame(function(){
        dragRaf=null, activeWrap.style.transition="none", activeWrap.style.transform="translateY("+deltaY+"px)"
      }))))
    });
    function endDrag(e){
      e&&e.pointerId!=null&&activePointers.delete(e.pointerId);
      if(dragging){
        if(dragRaf&&(cancelAnimationFrame(dragRaf), dragRaf=null), dragging=!1, lb.track&&(lb.track.style.transition=""), axis==="x"&&lb.slides&&lb.slides.length>1)Math.abs(deltaX)>40?lb.goToSlide(lb.current+(deltaX<0?1:-1)):lb.goToSlide(lb.current);
        else if(axis==="y"&&allPosts.length>1){
          var next=currentPostIndex+(deltaY<0?1:-1);
          Math.abs(deltaY)>60&&next>=0&&next<allPosts.length?goToPost(next, deltaY<0?"up":"down"):(activeWrap.style.transition="transform 0.28s ease", activeWrap.style.transform="translateY(0)")
        }axis=null, deltaX=0, deltaY=0
      }
    }lightboxPanelEl.addEventListener("pointerup", endDrag), lightboxPanelEl.addEventListener("pointerleave", endDrag), lightboxPanelEl.addEventListener("pointercancel", endDrag);
    var wheelCooldown=!1;
    lightboxPanelEl.addEventListener("wheel", function(e){
      if(!(allPosts.length<2)&&!(Math.abs(e.deltaY)<Math.abs(e.deltaX))&&!(wheelCooldown||Math.abs(e.deltaY)<12)){
        var next=currentPostIndex+(e.deltaY>0?1:-1);
        next<0||next>=allPosts.length||(e.preventDefault(), wheelCooldown=!0, goToPost(next, e.deltaY>0?"up":"down"), setTimeout(function(){
          wheelCooldown=!1
        }, 500))
      }
    }, {
      passive:!1
    })
  }/* MK 27.09.2026 : ouverture de la vidéo plein écran sur téléphone plus fluide.
     1. Les vidéos de la grille se mettent en pause tant que le plein écran est ouvert (un seul décodage vidéo à la fois), puis reprennent à la fermeture.
     2. Sur téléphone Android, la vidéo du plein écran ne commence à charger que 0,3 s après l'ouverture : l'image d'attente s'affiche tout de suite et l'animation d'ouverture n'est plus freinée.
        Sur iPhone, lancement immédiat (Safari exige que le son démarre dans le geste du doigt). */
  var mkIsIOS=/iPad|iPhone|iPod/.test(navigator.userAgent)||(navigator.platform==="MacIntel"&&navigator.maxTouchPoints>1);
  function mkPauseGrid(){
    try{
      window.__mkGridPaused=[].slice.call(document.querySelectorAll("[data-ig-grid] video")).filter(function(v){ return !v.paused });
      window.__mkGridPaused.forEach(function(v){ v.pause() })
    }catch(e){}
  }
  function mkResumeGrid(){
    try{
      (window.__mkGridPaused||[]).forEach(function(v){ v.muted=!0; var p=v.play(); p&&p.catch&&p.catch(function(){}) });
      window.__mkGridPaused=[]
    }catch(e){}
  }
  function openLightbox(postIndex, startIndex, opts){
    if(lightboxEl){
      opts=opts||{

      }, activeWrap=wrapA, wrapB.style.transition="none", wrapB.style.transform="translateY(100%)", wrapB.__media.innerHTML="";
      var ctl=renderPostInto(wrapA, postIndex, startIndex||0);
      activateController(ctl), wrapA.style.transition="none", wrapA.style.transform="translateY(0)", lightboxEl.removeAttribute("hidden"), mkPauseGrid(), document.body.style.overflow="hidden", window.mkLbEnter&&window.mkLbEnter(), animating=!1, opts.fromPopstate||history.pushState({
        igLightboxPost:postIndex, igLightboxSlide:startIndex||0
      }, "", location.href)
    }
  }/* MK 26.09.2026 : View product ouvre la fiche dans le contexte du mannequin de la photo.
     Homme -> /collections/men/products/..., femme -> /collections/women/..., photo mixte ou sans mannequin -> /collections/season-one/... (neutre).
     Le sexe vient des lignes des tags (« Male model… » / « Female model… ») ; pour un accessoire sans ligne, on prend les autres tags de la photo. */
  function mkGenderOfInfo(s){
    s=(s||"").toLowerCase();
    if(s.indexOf("female model")>-1) return "women";
    if(s.indexOf("male model")>-1) return "men";
    return null
  }
  function mkModelCtx(tags, handle){
    var own={}, all={}, n=0;
    (tags||[]).forEach(function(t){
      var g=mkGenderOfInfo(t.info);
      if(!g) return;
      all[g]=1;
      if(t.handle===handle){ own[g]=1; n++ }
    });
    var keys=Object.keys(n?own:all);
    return keys.length===1?keys[0]:"season-one"
  }
  function renderSheetItem(list, handle, mkCtx){
    var item=document.createElement("div");
    item.className="ig-sheet__item", list.appendChild(item), fetch(mkIgRoot()+"products/"+handle+".js").then(function(res){
      return res.ok?res.json():null
    }).then(function(p){
      if(!p){
        item.remove();
        return
      }var img=p.featured_image||p.images[0]||"", idx=sizeOptionIndex(p), sizeValues=idx!==-1?p.options[idx].values:[], selectedVariantId=p.variants.length===1?p.variants[0].id:null, imgEl=document.createElement("img");
      imgEl.src=img+"&width=150", imgEl.alt=p.title, item.appendChild(imgEl);
      var info=document.createElement("div");
      info.className="ig-sheet__item-info", info.innerHTML='<div class="ig-sheet__item-title">'+p.title+'</div><div class="ig-sheet__item-price">'+(function(){var c=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||"CHF";var v=p.price/100;return c+' '+(Math.round(v*100)%100===0?v.toFixed(0):v.toFixed(2));})()+"</div>", item.appendChild(info);
      var actions=document.createElement("div");
      actions.className="ig-sheet__item-actions", item.appendChild(actions);
      var viewBtn=document.createElement("a");
      viewBtn.className="ig-sheet__item-view", viewBtn.href=mkIgHref(mkCtx, p.url), viewBtn.textContent=mkT('s_c1445852edff', "View product"), actions.appendChild(viewBtn);
      var addBtn=document.createElement("button");
      addBtn.type="button", addBtn.className="ig-sheet__item-add", addBtn.textContent=mkT('s_f8893b912459', "Add to cart"), actions.appendChild(addBtn);
      var sizesDiv=null;
      sizeValues.length>1?(sizesDiv=document.createElement("div"), sizesDiv.className="ig-sheet__item-sizes", sizeValues.forEach(function(sizeVal){
        var variant=p.variants.find(function(v){
          return(idx!==-1?v["option"+(idx+1)]:v.title)===sizeVal
        }), sBtn=document.createElement("button");
        sBtn.type="button", sBtn.textContent=sizeVal, !variant||!variant.available?sBtn.disabled=!0:sBtn.addEventListener("click", function(){
          sizesDiv.querySelectorAll("button").forEach(function(b){
            b.classList.remove("is-selected")
          }), sBtn.classList.add("is-selected"), addToCart(variant.id, addBtn, item)
        }), sizesDiv.appendChild(sBtn)
      }), addBtn.addEventListener("click", function(){
        selectedVariantId?addToCart(selectedVariantId, addBtn, item):sizesDiv&&(info.appendChild(sizesDiv), addBtn.style.display="none")
      })):addBtn.addEventListener("click", function(){
        selectedVariantId&&addToCart(selectedVariantId, addBtn, item)
      })
    }).catch(function(){
      item.remove()
    })
  }function mkRefreshCartDrawer(){
    /* 28.10.2026 : après un ajout depuis l’IG grid, le tiroir panier est remis à jour (avant : il restait vide jusqu’au rechargement de la page). */
    try{
      var drawer=document.querySelector("cart-drawer");
      if(!drawer||typeof drawer.getSectionsToRender!=="function") return;
      var secs=drawer.getSectionsToRender();
      fetch(window.location.pathname+"?sections="+secs.map(function(s){ return s.id }).join(","), {headers:{Accept:"application/json"}}).then(function(r){ return r.json() }).then(function(st){
        secs.forEach(function(s){
          var el=s.selector?document.querySelector(s.selector):document.getElementById(s.id);
          if(el&&st&&st[s.id]) el.innerHTML=drawer.getSectionInnerHTML(st[s.id], s.selector);
        });
        drawer.classList.remove("is-empty");
        var inner=drawer.querySelector(".drawer__inner"); inner&&inner.classList.remove("is-empty");
      }).catch(function(){});
    }catch(e){}
  }function addToCart(variantId, btn, item){
    btn.disabled=!0;
    var original=btn.textContent;
    btn.textContent=mkT('s_268c06a28a1b', "Adding..."), fetch("/cart/add.js", {
      method:"POST", headers:{
        "Content-Type":"application/json"
      }, body:JSON.stringify({
        items:[{
          id:variantId, quantity:1
        }]
      })
    }).then(function(res){
      if(res.ok){
        btn.style.display="", btn.textContent=mkT('s_9599c19fb52a', "Added ✓"); mkRefreshCartDrawer();
        var sizes=item.querySelector(".ig-sheet__item-sizes");
        sizes&&sizes.remove(), fetch("/cart.js").then(function(r){
          return r.json()
        }).then(function(cart){
          document.querySelectorAll(".cart-count-bubble span[aria-hidden]").forEach(function(el){
            el.textContent=cart.item_count
          })
        }).catch(function(){

        })
      }else btn.disabled=!1, btn.textContent=original
    }).catch(function(){
      btn.disabled=!1, btn.textContent=original
    })
  }function buildGridSlide(m){
    var slide=document.createElement("div");
    if(slide.className="ig-slide", m.type==="video"&&m.videoSrc){
      var video=document.createElement("video");
      video.src=m.videoSrc, m.poster&&(video.poster=m.poster), video.muted=!0, video.setAttribute("muted", ""), video.loop=!0, video.playsInline=!0, video.setAttribute("playsinline", ""), video.autoplay=!0, video.setAttribute("autoplay", ""), video.setAttribute("webkit-playsinline", ""), video.disableRemotePlayback=!0, video.setAttribute("disableRemotePlayback", ""), video.setAttribute("x-webkit-airplay", "deny"), video.disablePictureInPicture=!0, video.preload="metadata", video.draggable=!1, slide.appendChild(video)
    }else{
      var img=document.createElement("img");
      img.loading="lazy", img.alt=m.imageAlt||"", img.draggable=!1, img.src=m.image, slide.appendChild(img)
    }return slide
  }/* MK 04.10.2026 (K) : lecture automatique de la vidéo de la grille, surtout sur iPhone.
   Avant : play() était appelé une seule fois, avant que la vidéo soit dans la page, sans nouvel essai. Safari (iPhone) ne lance pas
   une vidéo hors de la page et la met en pause quand elle sort de l'écran ou quand l'onglet passe en arrière-plan.
   Maintenant : attribut autoplay, relance quand la vidéo est visible, au retour sur l'onglet ou la page (bouton retour),
   et si le téléphone bloque la lecture automatique (mode économie d'énergie), lancement au premier toucher. */
var mkIO=("IntersectionObserver" in window)?new IntersectionObserver(function(es){
  es.forEach(function(e){
    var t=e.target;
    if(document.documentElement.classList.contains("mk-lb-open")) return;
    if(e.isIntersecting){ t.__mkPlay&&t.__mkPlay() } else { t.__mkPause&&t.__mkPause() }
  })
},{threshold:0.1}):null;
function mkObserveTile(t){ if(mkIO) mkIO.observe(t); else setTimeout(function(){ t.__mkPlay&&t.__mkPlay() },0) }
function mkKickVisible(){
  if(document.hidden||document.documentElement.classList.contains("mk-lb-open")) return;
  [].forEach.call(document.querySelectorAll(".ig-tile-cover"),function(t){
    var r=t.getBoundingClientRect();
    if(r.bottom>0&&r.top<window.innerHeight&&t.__mkPlay) t.__mkPlay()
  })
}
var mkGestureArmed=!1;
function mkArmGesture(){
  if(mkGestureArmed) return;
  mkGestureArmed=!0;
  var h=function(){
    document.removeEventListener("touchend",h,!0); document.removeEventListener("click",h,!0);
    mkGestureArmed=!1; mkKickVisible()
  };
  document.addEventListener("touchend",h,!0); document.addEventListener("click",h,!0)
}
document.addEventListener("visibilitychange",function(){ document.hidden||setTimeout(mkKickVisible,50) });
window.addEventListener("pageshow",function(){ setTimeout(mkKickVisible,50) });
function buildCoverTile(medias, postIndex){
    var tile=document.createElement("div");
    tile.className="ig-tile-cover";
    if(medias[0]&&medias[0].fullWidth){tile.classList.add("ig-tile-cover--full")}
    var track=document.createElement("div");
    track.className="ig-tile__track";
    var slides=medias.map(buildGridSlide);
    slides.forEach(function(s){
      track.appendChild(s)
    }), tile.appendChild(track);
    var current=0, dots=null;
    slides.length>1&&(dots=document.createElement("div"), dots.className="ig-dots", slides.forEach(function(_, i){
      var d=document.createElement("span");
      i===0&&d.classList.add("is-active"), dots.appendChild(d)
    }), tile.appendChild(dots));
    var badge=document.createElement("span");
    badge.className="ig-tile-cover__icon", tile.appendChild(badge);
    function updateBadge(){
      medias[current].type==="video"?(badge.innerHTML=playIconSVG(), badge.style.display="flex"):badge.style.display="none"
    }updateBadge();
    function updateGridVideoPlayback(){
      slides.forEach(function(slide, i){
        var v=slide.querySelector("video");
        v&&(i===current?v.play().catch(function(){

        }):v.pause())
      })
    }updateGridVideoPlayback();
tile.__mkPlay=function(){
  var v=slides[current]&&slides[current].querySelector("video");
  if(!v||!v.paused) return;
  v.muted=!0;
  var p=v.play();
  p&&p.catch&&p.catch(function(err){ if(err&&err.name==="NotAllowedError") mkArmGesture() })
};
tile.__mkPause=function(){ slides.forEach(function(s){ var v=s.querySelector("video"); v&&!v.paused&&v.pause() }) };
mkObserveTile(tile);
    function goTo(index){
      current=Math.max(0, Math.min(slides.length-1, index)), track.style.transform="translateX(-"+current*100+"%)", dots&&dots.querySelectorAll("span").forEach(function(d, i){
        d.classList.toggle("is-active", i===current)
      }), updateBadge()
    }var startX=0, deltaX=0, dragging=!1, moved=!1;
    track.addEventListener("pointerdown", function(e){
      dragging=!0, moved=!1, startX=e.clientX, track.style.transition="none"
    }), track.addEventListener("pointermove", function(e){
      dragging&&(deltaX=e.clientX-startX, Math.abs(deltaX)>6&&(moved=!0), slides.length>1&&e.preventDefault())
    });
    function endDrag(){
      dragging&&(dragging=!1, track.style.transition="", slides.length>1&&Math.abs(deltaX)>40?goTo(current+(deltaX<0?1:-1)):goTo(current), deltaX=0)
    }track.addEventListener("pointerup", endDrag), track.addEventListener("pointerleave", endDrag), track.addEventListener("pointercancel", endDrag);
    var wheelCooldown=!1;
    return track.addEventListener("wheel", function(e){
      slides.length<2||Math.abs(e.deltaX)<Math.abs(e.deltaY)||(e.preventDefault(), !(wheelCooldown||Math.abs(e.deltaX)<10)&&(wheelCooldown=!0, goTo(current+(e.deltaX>0?1:-1)), setTimeout(function(){
        wheelCooldown=!1
      }, 400)))
    }, {
      passive:!1
    }), tile.addEventListener("click", function(){
      if(moved){
        moved=!1;
        return
      }openLightbox(postIndex, current)
    }), tile
  }function initGrid(grid){
    if(grid.dataset.igInit!=="true"){
      grid.dataset.igInit="true";
      var posts=collectPosts(grid).map(function(sources){
        return sources.map(mediaData)
      });
      allPosts=posts, posts.forEach(function(medias, postIndex){
        grid.appendChild(buildCoverTile(medias, postIndex))
      }), grid.querySelectorAll(":scope > .ig-media-source").forEach(function(src){
        src.remove()
      })
    }
  }var historyRestored=!1;
  function init(){
    if(lightboxEl||initLightboxRefs(), document.querySelectorAll("[data-ig-grid]").forEach(initGrid), !historyRestored){
      historyRestored=!0;
      var state=history.state;
      state&&state.igLightboxPost!==void 0&&allPosts[state.igLightboxPost]&&openLightbox(state.igLightboxPost, state.igLightboxSlide||0, {
        fromPopstate:!0
      }), document.documentElement.style.visibility=""
    }
  }document.readyState==="loading"?document.addEventListener("DOMContentLoaded", init):init(), document.addEventListener("shopify:section:load", init)
})();